<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import Multiselect from 'vue-multiselect';
import Swal from '@/utils/ugm-swal';
/**
 * Starter component
 */
export default {
    components: { Layout, PageHeader, Multiselect, Swal },
    data() {
        return {
            title: "Crear Evento",
            items: [
                {
                text: "Eventos",
                href: "/"
                },
                {
                text: "Crear Evento",
                active: true
                }
            ],
            colegio:{},
            evento:{
                asunto:'',
                codigo:'',
                area:'Difusión',
                propietario:[],
                curso:[],
                tipo:'',
                subtipo:'',
                coordinador_evento:[],
                colegios_sel:[],
                observaciones:'',
                asistentes_por_curso: {}
            },
            bloquearColegio:false,
            sinColegio: false,
            tipos:[],
            subtipos:[],
            subtiposfilter:[],
            codigoPreview: '',
            cursos: ['1° medio', '2° medio', '3° medio', '4° medio', 'Egresado'],
            emailError:'',
            phoneerror:'',
            usuarios:[],
            colegios:[],
            isLoading:false
        };
    },
    computed:{
        isEmailValid() {
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailPattern.test(this.evento.email);
        }
    },
    methods:{
        normalizarCursoEvento(valor) {
            const normalizado = String(valor ?? '')
                .trim()
                .toLowerCase()
                .replace(/\s+/g, ' ');

            const map = {
                '1': '1° medio',
                '1°': '1° medio',
                '1º': '1° medio',
                '1 medio': '1° medio',
                '1° medio': '1° medio',
                '1º medio': '1° medio',
                'primero medio': '1° medio',
                '2': '2° medio',
                '2°': '2° medio',
                '2º': '2° medio',
                '2 medio': '2° medio',
                '2° medio': '2° medio',
                '2º medio': '2° medio',
                'segundo medio': '2° medio',
                '3': '3° medio',
                '3°': '3° medio',
                '3º': '3° medio',
                '3 medio': '3° medio',
                '3° medio': '3° medio',
                '3º medio': '3° medio',
                'tercero medio': '3° medio',
                '4': '4° medio',
                '4°': '4° medio',
                '4º': '4° medio',
                '4 medio': '4° medio',
                '4° medio': '4° medio',
                '4º medio': '4° medio',
                'cuarto medio': '4° medio',
                'egresado': 'Egresado',
                'egresados': 'Egresado',
            };

            return map[normalizado] || null;
        },
        normalizarCursosEvento(cursos) {
            return [...new Set((Array.isArray(cursos) ? cursos : [])
                .map((curso) => this.normalizarCursoEvento(curso))
                .filter(Boolean))];
        },
        validateEmail() {
            if (this.evento.email && !this.isEmailValid) {
                this.emailError = 'El correo electrónico no es válido.';
            } else {
                this.emailError = '';
            }
        },
        formatPhoneNumber() {
            // Elimina todo lo que no sea número
            let digits = this.evento.telefono.replace(/\D/g, "");

            // Agrega el prefijo "+56" si no está presente
            if (!digits.startsWith("56")) {
                digits = "56" + digits;
            }

            // Limita a un máximo de 11 caracteres (+56 + 9 dígitos)
            if (digits.length > 11) {
                digits = digits.slice(0, 11);
            }

            // Actualiza el input con el formato correcto
            this.evento.telefono = "+" + digits;
        },
        validatePhoneNumber() {
            // Validar que el número tenga exactamente 11 caracteres (+56 + 9 dígitos)
            if (this.evento.telefono.length !== 12) {
                this.phoneerror = "El número debe ser +56 seguido de 9 dígitos.";
            } else {
                this.phoneerror = "";
                //alert("Número válido: " + this.datos.telefono);
                // Aquí puedes continuar con el envío del formulario
            }
        },
        restrictToNumbers(event) {
            const allowedKeys = [
                "Backspace",
                "Tab",
                "ArrowLeft",
                "ArrowRight",
                "Delete",
            ];
            // Permitir teclas especiales y números
            if (
                !allowedKeys.includes(event.key) &&
                !/^\d$/.test(event.key) // Permitir solo números
            ) {
                event.preventDefault();
            }
        },
        msg(tipo, titulo){
            Swal.fire({
                icon: tipo,
                title: `<span style="color:#252C5F;font-weight:700;">${titulo}</span>`,
                confirmButtonText: 'Aceptar',
                confirmButtonColor: '#252C5F',
                background: '#fff',
                showConfirmButton: tipo !== 'success',
                timer: tipo === 'success' ? 2500 : undefined,
                customClass: { popup: 'rounded-lg' }
            });
        },
        msgval(campo) {
            Swal.fire({
                icon: 'warning',
                title: `<span style="color:#252C5F;font-weight:700;">Campo requerido</span>`,
                html: `<span style="color:#555;">Por favor completa el campo <strong style="color:#CB9700;">${campo}</strong> antes de continuar.</span>`,
                confirmButtonText: 'Entendido',
                confirmButtonColor: '#252C5F',
                background: '#fff',
                customClass: {
                    popup: 'rounded-lg',
                    confirmButton: 'px-4'
                }
            });
        },
        validacion() {
            const campos = {
                //correo_colegio_2: 'Correo Orientador',
                nombre_difusion: 'Nombre',
                fecha_inicio: 'Fecha Inicio',
                fecha_termino: 'Fecha Término',
                tipo: 'Tipo',
                subtipo: 'Subtipo',
                curso: 'Curso',
                coordinador_evento: 'Coordinador Evento',
            };
            if (!this.sinColegio) {
                if (!this.evento.colegios_sel || this.evento.colegios_sel.length === 0) {
                    this.msgval('Colegio');
                    return;
                }
            } else {
                const sc = this.colegios.find(c => c.rbd == 0 || c.nombre === 'Sin colegio');
                this.evento.colegios_sel = [sc || { rbd: 0, nombre: 'Sin colegio' }];
            }
            // if(this.evento.colegio.rbd=='0000000'){
            //     this.evento.correo_colegio_2=this.evento.email
            // }else{
            //     this.evento.correo_colegio_2=this.evento.colegio.correo_colegio_2
            // }
            for (let campo in campos) {
                if (!this.evento[campo]) {
                    this.msgval(campos[campo]);
                    return;
                }
            }
            this.crear_evento();
        },
        ver_evento(evento){
            localStorage.setItem('evento_codigo',evento);
            window.location.href = "/web/configuracion/eventos";
        },
        crear_evento() {
            this.isLoading = true;
            this.enviar_evento();
            /*axios.post('/api/validar_evento_solapado', {
                fecha_inicio: this.evento.fecha_inicio,
                fecha_termino: this.evento.fecha_termino,
                coordinador_evento: this.evento.coordinador_evento.id,
                rbd_colegio: this.evento.colegio.rbd,
                tipo_id: this.evento.tipo.id
            }).then(res => {
                if (!res.data.solapado) {
                    this.msg('error', 'Ya existe evento, colegio y tipo en el mismo horario.');
                    this.isLoading = false;
                } else {
                    this.enviar_evento(); // Si no hay solape, continuar
                }
            }).catch(error => {
                console.error(error);
                this.isLoading = false;
            });*/
        },
        buildFormData(colegiosList) {
            const primero = colegiosList[0] || { rbd: 0, nombre: 'Sin colegio' };
            const cursosNormalizados = this.normalizarCursosEvento(this.evento.curso);
            let formData = new FormData();
            formData.append('nombre_difusion', this.evento.nombre_difusion);
            formData.append('fecha_inicio', this.evento.fecha_inicio);
            formData.append('fecha_termino', this.evento.fecha_termino);
            formData.append('tipo', this.evento.tipo.codigo);
            formData.append('subtipo', this.evento.subtipo.codigo);
            formData.append('propietario', this.evento.propietario.name);
            formData.append('curso', JSON.stringify(cursosNormalizados));
            formData.append('asistentes_por_curso', JSON.stringify(this.evento.asistentes_por_curso));
            formData.append('user_id', this.evento.coordinador_evento.id);
            formData.append('coordinador_evento', this.evento.coordinador_evento.rut);
            formData.append('coordinador', this.evento.coordinador_evento.name);
            // Primer colegio para compatibilidad con campos legacy
            formData.append('rbd', primero.rbd);
            formData.append('colegio', primero.nombre);
            // Array completo de colegios como JSON
            if (colegiosList.length > 1) {
                formData.append('colegios_json', JSON.stringify(
                    colegiosList.map(c => ({ rbd: c.rbd, nombre: c.nombre }))
                ));
            }
            formData.append('observaciones', this.evento.observaciones || '');
            return formData;
        },
        async enviar_evento() {
            try {
                const res = await axios.post('/api/crear_evento', this.buildFormData(this.evento.colegios_sel));
                this.isLoading = false;
                if (res.data.estado) {
                    this.msg('success', res.data.mensaje);
                    setTimeout(() => this.ver_evento(res.data.codigo), 2500);
                } else {
                    this.msg(res.data.color, res.data.mensaje);
                }
            } catch (e) {
                console.error(e);
                this.isLoading = false;
            }
        },
        ver_subtipo(){            
            this.subtiposfilter = this.subtipos.filter((subtipo) => subtipo.tipo_id==this.evento.tipo.id);
            const anio = this.evento.fecha_inicio ? new Date(this.evento.fecha_inicio).getFullYear() : new Date().getFullYear();
            axios.get('/api/get_next_codigo', { params: { tipo_id: this.evento.tipo.id, anio } })
                .then(res => { this.codigoPreview = res.data.codigo || ''; });
        },
        toggleSinColegio() {
            if (this.sinColegio) {
                const sc = this.colegios.find(c => c.rbd == 0 || c.nombre === 'Sin colegio');
                this.evento.colegios_sel = [sc || { rbd: 0, nombre: 'Sin colegio' }];
            } else {
                this.evento.colegios_sel = [];
            }
        },
        labelselect_tipo ({ nombre }) {
            return `${nombre}`
        },
        labelselect_usuarios ({ name }) {
            return `${name}`
        },
        labelselect_colegio ({ nombre , rbd}) {
            return `${rbd}-${nombre}`
        },
        toggleCurso(curso) {
            const idx = this.evento.curso.indexOf(curso);
            if (idx >= 0) {
                this.evento.curso.splice(idx, 1);
                this.$delete(this.evento.asistentes_por_curso, curso);
            } else {
                this.evento.curso.push(curso);
                this.$set(this.evento.asistentes_por_curso, curso, null);
            }
        },
        isCursoSelected(curso) {
            return this.evento.curso.includes(curso);
        }
    },
    mounted(){
        axios.get('/api/get_tipos').then(res=>{
            this.tipos=res.data.tipos.filter(t=>t.codigo)
            this.subtipos=res.data.subtipos
            //this.subtiposfilter=res.data.subtipos
            //console.log(this.tipos);
            
        });
        
    },
    created(){
        if (localStorage.getItem("colegio")) {
            const colegio = localStorage.getItem("colegio");
            this.colegio=JSON.parse(colegio);
            localStorage.removeItem("colegio");
            //this.evento.colegio=this.colegio.nombre;
            //console.log(this.colegio);
            
            //this.evento.colegio= this.colegios.filter((us) => us.nombre==this.colegio.nombre)[0];
            this.evento.rbd=this.colegio.rbd;
            //this.evento.propietario= this.usuarios.filter((us) => us.name==this.user.name)[0];
            //this.evento.propietario=this.colegio.propietario;
            this.evento.user_id=this.colegio.user_id;
            this.evento.region=this.colegio.region;
            this.evento.comuna=this.colegio.comuna;
            this.evento.telefono=this.colegio.telefono;
            this.bloquearColegio=true
            axios.get('/api/get_usuarios').then(res=>{
                this.usuarios=res.data.usuarios;
                this.evento.propietario= this.usuarios.filter((us) => us.name==this.user.name)[0];
                this.evento.email= this.user.email;
                this.evento.telefono= this.user.telefono;
            });
            axios.get('/api/get_colegios').then(res=>{
                this.colegios=res.data.colegios;
                const found = this.colegios.find(us => us.nombre == this.colegio.nombre);
                this.evento.colegios_sel = found ? [found] : [];
            });
        }else{
            this.evento.rbd='0';
            this.evento.user_id='';
            this.evento.region='';
            this.evento.comuna='';
            this.evento.telefono='';
            this.sinColegio = true;
            axios.get('/api/get_usuarios').then(res=>{
                this.usuarios=res.data.usuarios;
                this.evento.propietario= this.usuarios.filter((us) => us.name==this.user.name)[0];
                this.evento.email= this.user.email;
                this.evento.telefono= this.user.telefono;
            });
            axios.get('/api/get_colegios').then(res=>{
                this.colegios=res.data.colegios;
                const sc = this.colegios.find(c => c.rbd == 0 || c.nombre === 'Sin colegio');
                this.evento.colegios_sel = sc ? [sc] : [];
                if (sc) this.evento.rbd = sc.rbd;
            });
        }
    }
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />

        <loading-message v-if="isLoading" />

        <div class="row">
            <div class="col-12">
                <div class="card">
                    <!-- Header -->
                    <div class="card-header py-3 d-flex align-items-center"
                        style="background: linear-gradient(135deg, #252C5F 0%, #61B7E4 100%); border-radius: 4px 4px 0 0;">
                        <i class="bx bx-calendar-plus font-size-24 text-white mr-2"></i>
                        <div>
                            <h5 class="text-white mb-0 font-weight-bold">Crear Evento</h5>
                            <small class="text-white" style="opacity:.8;">Completa los campos obligatorios para registrar un nuevo evento</small>
                        </div>
                    </div>

                    <div class="card-body pt-4">

                        <!-- Sección 1: Información general -->
                        <div class="mb-4">
                            <div class="d-flex align-items-center mb-3">
                                <div style="width:4px;height:20px;background:#252C5F;border-radius:2px;" class="mr-2"></div>
                                <h6 class="mb-0 font-weight-bold" style="color:#252C5F;">Información General</h6>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <b-form-group label-class="font-weight-medium small">
                                        <template #label>Nombre <span class="text-danger">*</span></template>
                                        <b-form-input v-model="evento.nombre_difusion" placeholder="Nombre del evento" />
                                    </b-form-group>
                                </div>
                                <div class="col-md-3">
                                    <b-form-group label-class="font-weight-medium small">
                                        <template #label>Fecha y hora inicio <span class="text-danger">*</span></template>
                                        <b-form-input type="datetime-local" v-model="evento.fecha_inicio" />
                                    </b-form-group>
                                </div>
                                <div class="col-md-3">
                                    <b-form-group label-class="font-weight-medium small">
                                        <template #label>Fecha y hora término <span class="text-danger">*</span></template>
                                        <b-form-input type="datetime-local" v-model="evento.fecha_termino" />
                                    </b-form-group>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-4">
                                    <b-form-group label-class="font-weight-medium small">
                                        <template #label>Tipo <span class="text-danger">*</span></template>
                                        <multiselect v-model="evento.tipo"
                                            :options="tipos"
                                            placeholder="Seleccionar tipo"
                                            selectLabel="Presiona para seleccionar"
                                            selectedLabel="Seleccionado"
                                            deselectLabel="Presiona para remover"
                                            :custom-label="labelselect_tipo"
                                            @select="ver_subtipo()">
                                            <template v-slot:noOptions><p>No hay opciones</p></template>
                                            <template v-slot:noResult><p>No se encuentra coincidencia</p></template>
                                        </multiselect>
                                    </b-form-group>
                                </div>
                                <div class="col-md-4">
                                    <b-form-group label-class="font-weight-medium small">
                                        <template #label>Subtipo <span class="text-danger">*</span></template>
                                        <multiselect v-model="evento.subtipo"
                                            :options="subtiposfilter"
                                            placeholder="Seleccionar subtipo"
                                            selectLabel="Presiona para seleccionar"
                                            selectedLabel="Seleccionado"
                                            deselectLabel="Presiona para remover"
                                            :custom-label="labelselect_tipo">
                                            <template v-slot:noOptions><p>No hay opciones</p></template>
                                            <template v-slot:noResult><p>No se encuentra coincidencia</p></template>
                                        </multiselect>
                                    </b-form-group>
                                </div>
                                <div class="col-md-4">
                                    <b-form-group label-class="font-weight-medium small">
                                        <template #label>Curso y N° Asistentes <span class="text-danger">*</span></template>
                                        <div class="d-flex flex-wrap" style="gap:8px;">
                                            <div v-for="c in cursos" :key="c"
                                                @click="toggleCurso(c)"
                                                :style="isCursoSelected(c)
                                                    ? 'background:#252C5F;color:#fff;border:2px solid #252C5F;border-radius:6px;padding:4px 10px;cursor:pointer;font-size:0.82rem;font-weight:600;'
                                                    : 'background:#f4f6fb;color:#252C5F;border:2px solid #dee2e6;border-radius:6px;padding:4px 10px;cursor:pointer;font-size:0.82rem;'">
                                                {{ c }}
                                            </div>
                                        </div>
                                        <div v-if="evento.curso.length > 0" class="mt-2">
                                            <div v-for="c in evento.curso" :key="'asi-'+c" class="d-flex align-items-center mb-1" style="gap:8px;">
                                                <span style="min-width:130px;font-size:0.82rem;color:#252C5F;font-weight:500;">{{ c }}</span>
                                                <b-form-input
                                                    type="number"
                                                    min="0"
                                                    v-model.number="evento.asistentes_por_curso[c]"
                                                    placeholder="N° asistentes"
                                                    size="sm"
                                                    style="max-width:130px;" />
                                            </div>
                                        </div>
                                    </b-form-group>
                                </div>
                            </div>
                            <div class="row" v-if="codigoPreview">
                                <div class="col-md-4">
                                    <b-form-group label-class="font-weight-medium small">
                                        <template #label>Código del Evento</template>
                                        <b-form-input :value="codigoPreview" readonly
                                            style="font-weight:700;letter-spacing:1px;background:#f4f6fb;color:#252C5F;" />
                                        <small class="text-muted">Código generado automáticamente al guardar</small>
                                    </b-form-group>
                                </div>
                            </div>
                        </div>

                        <hr />

                        <!-- Sección 2: Colegio -->
                        <div class="mb-4">
                            <div class="d-flex align-items-center mb-3">
                                <div style="width:4px;height:20px;background:#CB9700;border-radius:2px;" class="mr-2"></div>
                                <h6 class="mb-0 font-weight-bold" style="color:#252C5F;">Colegio</h6>
                            </div>
                            <div class="row">
                                <div class="col-md-8">
                                    <b-form-group label-class="font-weight-medium small">
                                        <template #label>
                                            Colegio <span class="text-danger" v-if="!sinColegio">*</span>
                                            <span v-if="!sinColegio && evento.colegios_sel.length > 1"
                                                class="badge ml-2"
                                                style="background:#252C5F;color:#fff;font-size:0.75rem;border-radius:12px;padding:2px 8px;">
                                                {{ evento.colegios_sel.length }} colegios seleccionados
                                            </span>
                                        </template>
                                        <div class="mb-2">
                                            <b-form-checkbox v-model="sinColegio" @change="toggleSinColegio" switch>
                                                <span class="text-muted small">Sin colegio</span>
                                            </b-form-checkbox>
                                        </div>
                                        <div v-if="sinColegio"
                                            class="d-flex align-items-center px-3 py-2"
                                            style="background:#f4f6fb;border:1px solid #dee2e6;border-radius:6px;color:#6c757d;font-size:0.9rem;">
                                            <i class="bx bx-buildings mr-2" style="font-size:1.1rem;"></i>
                                            Sin colegio asignado
                                        </div>
                                        <multiselect
                                            v-else
                                            v-model="evento.colegios_sel"
                                            :options="colegios"
                                            :multiple="true"
                                            :close-on-select="false"
                                            placeholder="Seleccionar colegio(s)"
                                            selectLabel="Seleccionar"
                                            selectedLabel="✓"
                                            deselectLabel="Remover"
                                            :custom-label="labelselect_colegio">
                                            <template v-slot:noOptions><p>No hay opciones</p></template>
                                            <template v-slot:noResult><p>No se encuentra coincidencia</p></template>
                                        </multiselect>
                                    </b-form-group>
                                </div>
                            </div>
                        </div>

                        <hr />

                        <!-- Sección 3: Responsables -->
                        <div class="mb-4">
                            <div class="d-flex align-items-center mb-3">
                                <div style="width:4px;height:20px;background:#4CAF50;border-radius:2px;" class="mr-2"></div>
                                <h6 class="mb-0 font-weight-bold" style="color:#252C5F;">Responsables</h6>
                            </div>
                            <div class="row">
                                <div class="col-md-4">
                                    <b-form-group label="Responsable" label-class="font-weight-medium small">
                                        <multiselect
                                            v-model="evento.propietario"
                                            :options="usuarios"
                                            placeholder="Seleccionar usuario"
                                            selectLabel="Presiona para seleccionar"
                                            selectedLabel="Seleccionado"
                                            deselectLabel="Presiona para remover"
                                            :custom-label="labelselect_usuarios">
                                            <template v-slot:noOptions><p>No hay opciones</p></template>
                                            <template v-slot:noResult><p>No se encuentra coincidencia</p></template>
                                        </multiselect>
                                    </b-form-group>
                                </div>
                                <div class="col-md-4">
                                    <b-form-group label-class="font-weight-medium small">
                                        <template #label>Coordinador Evento <span class="text-danger">*</span></template>
                                        <multiselect
                                            v-model="evento.coordinador_evento"
                                            :options="usuarios"
                                            placeholder="Seleccionar usuario"
                                            selectLabel="Presiona para seleccionar"
                                            selectedLabel="Seleccionado"
                                            deselectLabel="Presiona para remover"
                                            :custom-label="labelselect_usuarios">
                                            <template v-slot:noOptions><p>No hay opciones</p></template>
                                            <template v-slot:noResult><p>No se encuentra coincidencia</p></template>
                                        </multiselect>
                                    </b-form-group>
                                </div>
                            </div>
                        </div>

                        <!-- Observaciones -->
                        <div class="mb-4">
                            <div class="row">
                                <div class="col-12">
                                    <b-form-group label-class="font-weight-medium small">
                                        <template #label>Observaciones</template>
                                        <b-form-textarea
                                            v-model="evento.observaciones"
                                            placeholder="Ingresa observaciones del evento (opcional)"
                                            rows="3"
                                            max-rows="6" />
                                    </b-form-group>
                                </div>
                            </div>
                        </div>

                        <!-- Botón guardar -->
                        <div class="row mt-2">
                            <div class="col-12 d-flex justify-content-end">
                                <b-button variant="primary" size="lg" @click="validacion" :disabled="isLoading"
                                    style="background:#252C5F;border-color:#252C5F;min-width:200px;">
                                    <b-spinner small v-if="isLoading" class="mr-2"></b-spinner>
                                    <i class="bx bx-check-circle mr-2" v-else></i>
                                    Crear Evento
                                </b-button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>
